export const frontmatter = {
  title: "An overview",
  order: 2,
}

# SCALE
> SCALE is the native token of Scale.Farm
